export class SearchModel {
  keyWord: any;
  agentCode: any;
  pageable: any;
  page: any;
  size: any;
  sort: any;
}

export class SearchProsepectModel extends SearchModel{
  personalID: any;
  name: any;
  tel: any;
}

export class SearchProductGroupPanel {
  productCategoryId: any;
  productTypeId: any;
}

export class deleteLead {
  _personalId: any;
  agentcode: any;
}